import { useReducer } from "react";

export interface InstallmentDetail {
	Installment_id: string;
	Installment_number: number;
	Installment_amount: string;
	Installment_type_amount: string;
	Installment_proposalId: string;
	name: string;
	document: string;
	Installment_due_date: string;
	Installment_obs?: string;
	Installment_payment_method: string;
	InstallmentsCount?: number;
}

type State = {
	isLoading: boolean;
	rows: InstallmentDetail[];
	selectedIds: string[];
	openConfirmModal: boolean;
};

type Action =
	| { type: "SET_LOADING"; payload: boolean }
	| { type: "SET_ROWS"; payload: InstallmentDetail[] }
	| { type: "TOGGLE_SELECT_ONE"; payload: string }
	| { type: "TOGGLE_SELECT_ALL"; payload: string[] }
	| { type: "SET_SELECTED_IDS"; payload: string[] }
	| { type: "OPEN_CONFIRM_MODAL" }
	| { type: "CLOSE_CONFIRM_MODAL" };

const initialState: State = {
	isLoading: false,
	rows: [],
	selectedIds: [],
	openConfirmModal: false,
};

function reducer(state: State, action: Action): State {
	switch (action.type) {
		case "SET_LOADING":
			return { ...state, isLoading: action.payload };
		case "SET_ROWS":
			return { ...state, rows: action.payload };
		case "TOGGLE_SELECT_ONE":
			return {
				...state,
				selectedIds: state.selectedIds.includes(action.payload)
					? state.selectedIds.filter((id) => id !== action.payload)
					: [...state.selectedIds, action.payload],
			};
		case "TOGGLE_SELECT_ALL":
			return {
				...state,
				selectedIds: state.selectedIds.length === action.payload.length ? [] : [...action.payload],
			};
		case "SET_SELECTED_IDS":
			return { ...state, selectedIds: action.payload };
		case "OPEN_CONFIRM_MODAL":
			return { ...state, openConfirmModal: true };
		case "CLOSE_CONFIRM_MODAL":
			return { ...state, openConfirmModal: false };
		default:
			return state;
	}
}

export function useInstallmentModalReducer() {
	const [state, dispatch] = useReducer(reducer, initialState);

	return {
		state,
		dispatch,
	};
}
